import { Component, OnInit, computed, signal } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "../../services/api.service";
import { InscriptionCategoryDTO } from "../../DTO/InscriptionsDTO";
import { CommunityDTO } from "../../DTO/CommunityDTO";
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { InscriptionFilterDTO } from 'src/app/DTO/filters/InscriptionFilterDTO';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { InscriptionMinDTO } from 'src/app/DTO/min/InscriptionMinDTO';

@Component({
  selector: 'app-inscriptions',
  templateUrl: './inscriptions.component.html',
  styleUrl: './inscriptions.component.scss'
})
export class InscriptionsComponent implements OnInit {
  inscriptions = signal<InscriptionMinDTO[] | undefined>(undefined);
  community = signal<CommunityDTO | undefined>(undefined);
  communityName: string = "";
  public defaultImg: string;
  public isLoading = signal(true);
  public page = signal(1);
  public collectionSize = signal(1);
  public faArrowRight = faArrowRight;
  public faArrowLeft = faArrowLeft;
  public first = 0;
  public rows = signal(9);
  public filtersLoading = signal(true);
  public categoriesOptions = signal<InscriptionCategoryDTO[]>([]);
  public categoriesSelected = signal<number[]>([]);
  public filters: InscriptionFilterDTO = new InscriptionFilterDTO();
  public isIframe = signal(false);

  public loading = computed(() => this.isLoading() || this.filtersLoading());
  public showEmptyInitial = computed(() =>
    !this.inscriptions() && !this.isLoading() && !this.filtersLoading()
  );
  public showNoInscriptions = computed(() =>
    !this.isLoading() && (!this.inscriptions() || this.inscriptions().length === 0)
  );
  public showInscriptions = computed(() =>
    this.inscriptions() != null && !this.isLoading()
  );

  private pageSize = 9;

  constructor(
    private actRoute: ActivatedRoute,
    private apiService: ApiService,
    private themeService: ThemeService
  ) {
    this.communityName = this.actRoute.snapshot.params['community'];
  }

  async ngOnInit() {
    this.isIframe.set(await this.themeService.getIsIframe());

    this.init();
  }

  public filterInscriptions(newFilter?: boolean) {
    if (newFilter) {
      this.first = 0;
      this.page.set(1);
    }

    this.isLoading.set(true);

    this.filters = {
      skip: this.first,
      top: this.pageSize,
      categories: this.categoriesSelected(),
    };

    this.apiService.getInscriptionsFiltered(
      this.communityName,
      this.filters
    )
      .subscribe(response => {
        this.countInscriptions();
        this.inscriptions.set(response);
        this.isLoading.set(false);
      });
  }

  public pageChange(event: { first?: number; rows?: number }) {
    this.first = event.first ?? 0;
    this.rows.set(event.rows ?? 9);
    this.filters.skip = this.first;
    this.filterInscriptions();
  }

  private countInscriptions() {
    this.apiService.countInscriptionsFiltered(
      this.communityName,
      this.filters
    )
      .subscribe(total => this.collectionSize.set(total));
  }

  private getCommunity() {
    this.apiService.getCommunityByCode(this.communityName).subscribe(responseData => {
      this.community.set(responseData);

      this.getInscriptionsCategories();
    });
  }

  private getInscriptionsCategories() {
    const c = this.community();
    if (!c) return;

    this.apiService.getInscriptionCategories(c.id)
      .subscribe(response => {
        this.categoriesOptions.set(response);
        this.filtersLoading.set(false);
      });
  }

  private init() {
    this.getCommunity();

    this.filters = {
      skip: this.first,
      top: this.pageSize,
      categories: []
    };

    this.filterInscriptions();
  }
}
